import {
    RuleValueRemove,
    RuleValueWaterMarkMajor,
    RuleValueWaterMarkMinor,
    RuleValueDuplicate,
    RuleValueNoInteriorPhotos,
    RuleValueNoExteriorPhotos,
    RuleValueNoKitchenPhotos,
    RuleValueNoBedroomPhotos,
    RuleValueNoBathroomPhotos,
    RuleValueNoLoungePhotos
} from './rules/image';

import {
    StatusInReview,
    StatusReviewed,
    StatusPending,
    StatusDoNotReview,
    StatusReReview
} from './consts';

const mediaLabels = {
    'video': 'Video',
    'floorplan': 'Floor Plan',
    'virtualtour': 'Virtual Tour'
};

const extraPropertFeatures = [
    {
        label: 'PriceInEuro',
        name: 'priceInEuro',
        type: 'number',
        mapping: 'PriceInEuro'
    },
    {
        label: 'HighestPriceInReferedCurrency',
        name: 'highestPriceInReferedCurrency',
        type: 'number',
        mapping: 'HighestPriceInReferedCurrency'
    },
    {
        label: 'OfferType',
        name: 'offerType',
        type: 'select',
        mapping: 'OfferType'
    },
    {
        label: 'PropertyType',
        name: 'propertyType',
        type: 'select',
        mapping: 'PropertyType'
    }
];

const corePropertyFeatures = [
    {
        label: 'Bedrooms',
        name: 'bedrooms',
        type: 'number',
        mapping: 'Bedrooms',
        validate: ( value ) => {
            let result = {
                error: null
            };

            if ( value < 0 ) {
                result.error = new Error( 'Bedrooms cannot be < 0' );
            }

            return result;
        }
    },
    {
        label: 'Bathrooms',
        name: 'bathrooms',
        type: 'number',
        mapping: 'Bathrooms',
        validate: ( value ) => {
            let result = {
                error: null
            };

            if ( value < 0 ) {
                result.error = new Error( 'Bathrooms cannot be < 0' );
            }

            return result;
        }
    },
    {
        label: 'Toilets',
        name: 'toilets',
        type: 'number',
        mapping: 'Toilets',
        validate: ( value ) => {
            let result = {
                error: null
            };

            if ( value < 0 ) {
                result.error = new Error( 'Toilets cannot be < 0' );
            }

            return result;
        }
    },
    {
        label: 'Plot <span class="small">m<sup>2</sup></span>',
        name: 'plot',
        type: 'number',
        mapping: 'Plot',
        validate: ( value ) => {
            let result = {
                error: null
            };

            if ( value < 0 ) {
                result.error = new Error( 'Plot cannot be < 0' );
            }

            return result;
        }
    },
    {
        label: 'Living Area <span class="small">m<sup>2</sup></span>',
        name: 'living-area',
        type: 'number',
        mapping: 'Build',
        validate: ( value ) => {
            let result = {
                error: null
            };

            if ( value < 0 ) {
                result.error = new Error( 'Living Area cannot be < 0' );
            }

            return result;
        }
    },
    {
        label: 'Floor Number',
        name: 'floor-number',
        type: 'text',
        mapping: 'FloorNumber',
        title: 'Only values between 1-50 are displayed on the website'
    },
    {
        label: 'Total Floors',
        name: 'total-floor-numbers',
        type: 'number',
        mapping: 'Levels',
        title: 'Only values between 1-50 are displayed on the website',
        validate: ( value ) => {
            let result = {
                error: null
            };

            if ( value < 0 ) {
                result.error = new Error( 'Total Floors cannot be < 0' );
            }

            return result;
        }
    },
    {
        label: 'Year Built',
        name: 'year-built',
        type: 'number',
        mapping: 'YearBuilt'
    },
    {
        label: 'E.R.C',
        title: 'Energy Consumption Rating',
        name: 'erc-rating',
        mapping: 'EnergyRatingConsumption',
        type: 'select',
        options: [
            {
                label: 'A',
                value: 'A'
            },
            {
                label: 'B',
                value: 'B'
            },
            {
                label: 'C',
                value: 'C'
            },
            {
                label: 'D',
                value: 'D'
            },
            {
                label: 'E',
                value: 'E'
            },
            {
                label: 'F',
                value: 'F'
            },
            {
                label: 'G',
                value: 'G'
            },
            {
                label: 'Unknown',
                value: ''
            }
        ]
    },
    {
        label: 'E.R.E',
        title: 'Energy Emissions Rating',
        name: 'ere-rating',
        mapping: 'EnergyRatingEmissions',
        type: 'select',
        options: [
            {
                label: 'A',
                value: 'A'
            },
            {
                label: 'B',
                value: 'B'
            },
            {
                label: 'C',
                value: 'C'
            },
            {
                label: 'D',
                value: 'D'
            },
            {
                label: 'E',
                value: 'E'
            },
            {
                label: 'F',
                value: 'F'
            },
            {
                label: 'G',
                value: 'G'
            },
            {
                label: 'Unknown',
                value: ''
            }
        ]
    },
    {
        label: 'KM to Town',
        name: 'nearest-town',
        type: 'number',
        mapping: 'DistanceToTown'
    },
    {
        label: 'KM to Airport',
        name: 'Nearest Airport',
        type: 'number',
        mapping: 'DistanceToAirport'
    },
    {
        label: 'KM to Marina',
        name: 'nearest-marina',
        type: 'number',
        mapping: 'DistanceToMarina'
    },
    {
        label: 'KM to Beach',
        name: 'nearest-beach',
        type: 'number',
        mapping: 'DistanceToBeach'
    },
    {
        label: 'KM to Country',
        name: 'nearest-country',
        type: 'number',
        mapping: 'DistanceToCountry'
    },
    {
        label: 'KM to Golf',
        name: 'nearest-golf',
        type: 'number',
        mapping: 'DistanceToGolf'
    }
];

const corePropertyFeatureAsClasses = () => {
    let o = {
        PriceInEuro: {
            ruleAdd: false,
            ruleNone: true,
            hasError: false
        },
        HighestPriceInReferedCurrency: {
            ruleAdd: false,
            ruleNone: true,
            hasError: false
        },
        OfferType: {
            ruleAdd: false,
            ruleNone: true,
            hasError: false
        },
        PropertyType: {
            ruleAdd: false,
            ruleNone: true,
            hasError: false
        }
    };
    corePropertyFeatures.forEach( feature => {
        o[ feature.mapping ] = {
            ruleAdd: false,
            rulleNone: true,
            hasError: false
        };
    } );
    return o;
};

const corePropertyFeatureAsValues = () => {
    let o = {
        PriceInEuro: null,
        HighestPriceInReferedCurrency: null,
        OfferType: null,
        PropertyType: null
    };
    corePropertyFeatures.forEach( feature => {
        o[ feature.mapping ] = null;
    } );
    return o;
};

const reviewStatuses = {
    [ StatusInReview ]: {
        label: 'In Review',
        value: StatusInReview,
        default: false,
        hide: true
    },
    [ StatusReviewed ]: {
        label: 'Reviewed',
        value: StatusReviewed,
        default: false
    },
    [ StatusPending ]: {
        label: 'Pending',
        value: StatusPending,
        default: true
    },
    [ StatusDoNotReview ]: {
        label: 'Do Not Review',
        value: StatusDoNotReview,
        default: false
    },
    [ StatusReReview ]: {
        label: 'Re-Review',
        value: StatusReReview,
        default: false
    }
};

const orderByOptions = [
    {
        label: 'Login Descending',
        value: 'DESC',
        default: true
    },
    {
        label: 'Login Ascending',
        value: 'ASC',
        default: true
    }
];

const photoRulesIndividual = [
    {
        label: 'Hidden',
        name: RuleValueRemove,
        forAll: true
    },
    {
        label: 'Minor Watermark',
        name: RuleValueWaterMarkMinor,
        forAll: true
    },
    {
        label: 'Major Watermark',
        name: RuleValueWaterMarkMajor,
        forAll: true
    },
    {
        label: 'Duplicate',
        name: RuleValueDuplicate,
        forAll: false
    }
];

const photoRulesGrouped = [
    {
        label: 'Missing Interior Photos',
        name: RuleValueNoInteriorPhotos
    },
    {
        label: 'Missing Exterior Photos',
        name: RuleValueNoExteriorPhotos
    },
    {
        label: 'Missing Kitchen Photos',
        name: RuleValueNoKitchenPhotos
    },
    {
        label: 'Missing Lounge Photos',
        name: RuleValueNoLoungePhotos
    },
    {
        label: 'Missing Bedroom Photos',
        name: RuleValueNoBedroomPhotos
    },
    {
        label: 'Missing Bathroom Photos',
        name: RuleValueNoBathroomPhotos
    }
];

const langNameToCode = {
    'en': 'English',
    'es': 'Spanish',
    'de': 'German',
    'pl': 'Polish',
    'fr': 'French',
    'it': 'Italian',
    'nl': 'Dutch',
    'sv': 'Swedish',
    'no': 'Norwegian',
    'da': 'Danish',
    'fi': 'Finnish',
    'pt': 'Portuguese'
};

const availableLanguages = [
    {
        name: 'English',
        code: 'en'
    },
    {
        name: 'Spanish',
        code: 'es'
    },
    {
        name: 'Polish',
        code: 'pl'
    },
    {
        name: 'German',
        code: 'de'
    },
    {
        name: 'French',
        code: 'fr'
    },
    {
        name: 'Italian',
        code: 'it'
    },
    {
        name: 'Dutch',
        code: 'nl'
    },
    {
        name: 'Swedish',
        code: 'sv'
    },
    {
        name: 'Norwegian',
        code: 'no'
    },
    {
        name: 'Danish',
        code: 'da'
    },
    {
        name: 'Finnish',
        code: 'fi'
    },
    {
        name: 'Portuguese',
        code: 'pt'
    }
];

export {
    reviewStatuses,
    orderByOptions,
    photoRulesIndividual,
    photoRulesGrouped,
    availableLanguages,
    corePropertyFeatures,
    mediaLabels,
    langNameToCode,
    corePropertyFeatureAsClasses,
    corePropertyFeatureAsValues,
    extraPropertFeatures
};



// WEBPACK FOOTER //
// ./src/components/property-qc/common.js